import React from 'react';
import {
  SKYX_MODAL_CHROME,
  SKYX_NEW_MODAL_DIALOG_CLASS,
  SKYX_POPUP_ROOT_ATTR,
} from './SkyxNewModalChrome.styles';

/** Layout/animation props live on the glow shell; chrome + clipping live on the inner panel. */
export function splitSkyxNewModalPanelStyles(panelStyle: React.CSSProperties): {
  shell: React.CSSProperties;
  inner: React.CSSProperties;
} {
  const {
    transform,
    opacity,
    transition,
    width,
    maxWidth,
    minWidth,
    margin,
    flexShrink,
    alignSelf,
    borderRadius,
    ...innerRest
  } = panelStyle;

  return {
    shell: {
      position: 'relative',
      overflow: 'visible',
      width,
      maxWidth,
      minWidth,
      margin,
      flexShrink,
      alignSelf,
      transform,
      opacity,
      transition,
      borderRadius,
    },
    inner: {
      ...innerRest,
      borderRadius,
      width: width ?? '100%',
      display: innerRest.display ?? 'flex',
      flexDirection: innerRest.flexDirection ?? 'column',
      minHeight: 0,
      overflow: 'hidden',
      border: innerRest.border ?? SKYX_MODAL_CHROME.border,
      boxShadow: innerRest.boxShadow ?? SKYX_MODAL_CHROME.boxShadow,
    },
  };
}

export interface SkyxNewModalPanelShellProps
  extends React.HTMLAttributes<HTMLDivElement> {
  panelStyle: React.CSSProperties;
  /** When false, renders a plain div (non-skyx routes). */
  enabled?: boolean;
}

export const SkyxNewModalPanelShell: React.FC<SkyxNewModalPanelShellProps> = ({
  panelStyle,
  className,
  children,
  style,
  enabled = true,
  ...rest
}) => {
  if (!enabled) {
    return (
      <div {...rest} className={className} style={{ ...panelStyle, ...style }}>
        {children}
      </div>
    );
  }

  const { shell, inner } = splitSkyxNewModalPanelStyles(panelStyle);

  return (
    <div
      {...rest}
      {...{ [SKYX_POPUP_ROOT_ATTR]: '' }}
      className={[SKYX_NEW_MODAL_DIALOG_CLASS, className]
        .filter(Boolean)
        .join(' ')}
      style={{ ...shell, ...style }}
    >
      <div style={inner}>{children}</div>
    </div>
  );
};
